<template>
  <div class="w-100">
     <LoadingSpinner v-if="!oliverSalesLoaded" />
    <div class="card px-2 py-3 my-4 shadow-sm d-flex" v-else>
      <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
        <div class="input-group-prepend">
          <span class="input-group-text" id="inputGroup-sizing-sm"
            >Sale</span
          >
        </div>
        <IndustrySearch
          :option_list="userOliverSales"
          :default_values="userOliverSale"
          :key="3"
          :multiple="false"
          :disabled="loadingData"
          @selected="selectOliverSale"
          class="form-control inline-table"
        />
      </div>

      <div
        class="d-flex flex-row justify-content-center py-0 my-0 w-100 pt-4"
        v-if="userOliverSale[0] == '0' && oliverSalesLoaded"
      >
        <div class="col-lg-12 pt-2 text-center py-0">
          <img
            src="@/assets/images/search-oliver3.png"
            class="rounded mx-auto d-block py-0"
            width="180px"
          />
        </div>
      </div>
  
      <LoadingSpinner v-if="loadingData || loadingTotalData && userOliverSale[0] != '0'" />

      <div class="col-md-12 w-100 my-4" v-if="!loadingData && !loadingTotalData && userOliverSale[0] != '0'">
        <div class="row float-left">
          <div class="col-md-12">
            <span class="mr-1">{{ $t("lang.label.results") }}:</span>
            <small v-if="total < 0" class="ml-1 text-primary mr-4"
              >{{ $t("lang.search.calculating") }}...</small
            >
            <strong class="mr-5" v-else>{{ total }}</strong>
          </div>
        </div>
            <div class="row text-center">
              <div class="col-md-12">
                <Pagination
                  :total="total"
                  :totalpage="totalPageStep"
                  :model="pagination"
                  :limit="false"
                  :color="'primary'"
                  @changePage="getData"
                  key="paginationkey"
                ></Pagination>
              </div>
            </div>
      </div>

  
      <!-- Data table -->
      <div class="col-12 mt-3" v-if="!loadingData && userOliverSale[0] != '0'">
        <div class="row">
          <div class="col-12 card p-2">
            <Table
              :key="key"
              :headers="headers"
              :cols="cols"
              :data="data"
              :model="[]"
              :checkbox="false"
              :notselect="true"          
              @openClient="openClient"
              @openTarget="openTarget"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { usersService } from "@/_services";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import moment from 'moment';
import { mapState} from "vuex";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from '../LoadingSpinner.vue';
import Pagination from "@/components/Common/Pagination.vue";



export default {
  name: 'OliverSaleActions',

  components: {
    IndustrySearch,
    Table,
    LoadingSpinner,
    Pagination,
  },

  data() {
    return {
      loadingData: false,
      loadingTotalData: false,
      pagination: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      total: -1,
      getTotal: 0,
      filtersPage: {
        userOliverSale: null,
      },
      lastFilterPage: [],
      userOliverSale: ["0"],
      userOliverSales: [{ id: "0", label: "Select option..."}, { id: "all", label: "All"}],
      oliverSalesLoaded: false,
      key: 3232323,
      data: [],
      headers: [
        {
          label: "Date/Hour",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 1,
        },
        {
          label: "Sales",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 2,
        },
        {
          label: "Action type",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 3,
        },
        {
          label: "Client",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 4,
        },
        {
          label: this.$t("lang.label.order"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
        }
      ],

      cols: [
        [
          {
            value: "created",
          },
        ], 
        [
          {
            value: "sale",
          },
        ],
        [
          {
            value: "action",
          },
        ],
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "openClient",
          },
        ], 
        [
          {
            value_label: "target_name",
            value_emit: "id",
            class: "text-primary",
            type: "emit",
            emit: "openTarget",
          },
        ],
      ],
     
    };
  },

  created() {
    this.init()
  },

  computed: {
    ...mapState({
      user: (state) => state.authentication.user,
    }),
    isUserOliverSale() {
      return (this.user.role_id == 1 && this.user.user_constraint_id == 2);
    },
    totalPageStep() {
      return this.data.length;
    },
  },


  methods: {

    init(){
      this.getUserOliverSales()
    },

    openTarget(target_id) {
        let url = "/orders/" + target_id;
        window.open(url, "_blank");
    },
    openClient(client_id) {
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },

    getUserOliverSales(){
      usersService.getUserOliverSales(true, 0, true)
      .then( res => {
        if(res.result.length > 0) {
          const userOliverSalesWithlabel = res.result.map( el => ({ ...el, label: el.lastname + ", " + el.name}))
          this.userOliverSales.push(...userOliverSalesWithlabel)
          this.oliverSalesLoaded = true

          if(this.isUserOliverSale) {
            const findUserOliverSale = this.userOliverSales.find(el => el.id == this.user.id)
            if(findUserOliverSale) {
              this.userOliverSale = [findUserOliverSale.id]
              this.getDataMonths()
            }
          }
        }
      })
      .catch( err => console.err(err))
    },

    selectOliverSale(value){
      this.userOliverSale["0"] = value.id;
      if(value.id != 0){
        this.pagination.currentPage = 1;
        this.pagination.cantPerPage = 25;
        this.getData();
      }
    },
    getData(){
      if (
        JSON.stringify(this.filtersPage) != JSON.stringify(this.lastFilterPage)
      ) {
        this.getTotalData();
      }
      this.data = []
      this.loadingData = true;
      this.getTotal = 0;
      let searchFilter = this.filtersPage;
      searchFilter.cantPerPage = this.pagination.cantPerPage;
      searchFilter.currentPage = this.pagination.currentPage;
      searchFilter.getTotal = this.getTotal;
      searchFilter.userOliverSale = this.userOliverSale["0"];

      usersService.getOliverSalesActions(this.userOliverSale["0"], this.pagination.currentPage, this.pagination.cantPerPage, this.getTotal)
        .then( res => {
          if (res.result){
            this.data = res.result.list;
          }
          this.loadingData = false;
        })
        .catch( err => console.error(err))      

    },

    getTotalData(){
      this.data = []
      this.loadingTotalData = true;
      this.getTotal = 1;
      let searchFilter = this.filtersPage;
      searchFilter.cantPerPage = this.pagination.cantPerPage;
      searchFilter.currentPage = this.pagination.currentPage;
      searchFilter.getTotal = this.getTotal;
      searchFilter.userOliverSale = this.userOliverSale["0"];

      usersService.getOliverSalesActions(this.userOliverSale["0"], this.pagination.currentPage, this.pagination.cantPerPage, this.getTotal)
        .then( res => {
          if (res.result){
            this.total = res.result.total;
          }
          this.loadingTotalData = false;
        })
        .catch( err => console.error(err))      

    },
  },

};
</script>
